import { useState } from "react";
import { FiRefreshCw } from "react-icons/fi";
import { MdWarningAmber } from "react-icons/md";

import styles from "./UpdateBanner.module.scss";

interface Props {
  force?: boolean;
}

export default function UpdateBanner({ force = false }: Props) {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div
      className={`${styles.banner} ${force ? styles.danger : styles.gradient}`}
    >
      <span className={styles.icon}>
        {force ? <MdWarningAmber size={22} /> : <FiRefreshCw size={18} />}
      </span>

      <span className={styles.message}>
        {force
          ? "A required update is available. Please refresh to continue."
          : "A new version of the app is available."}
      </span>

      <button
        className={styles.refreshBtn}
        onClick={() => window.location.reload()}
      >
        Refresh
      </button>

      {!force && (
        <button
          className={styles.dismissBtn}
          onClick={() => setDismissed(true)}
          aria-label="Dismiss"
        >
          ✕
        </button>
      )}
    </div>
  );
}
